module.exports = __webpack_public_path__ + "static/floor-work-2128757ee4e690cce723cd028333ba25.jpg";